import { render, staticRenderFns } from "./UserLink.vue?vue&type=template&id=2b7e7584&"
import script from "./UserLink.vue?vue&type=script&lang=js&"
export * from "./UserLink.vue?vue&type=script&lang=js&"
import style0 from "./UserLink.vue?vue&type=style&index=0&id=2b7e7584&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports